import template from './fundingDocumentModal.html';
import controller from './fundingDocumentModal.controller';

let FundingDocumentModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-info animated zoomIn"
};

export default FundingDocumentModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/fundingDocumentModal/fundingDocumentModal.component.js